export const OPINION_TYPES = {
  LIKE: "like",
  DISLIKE: "dislike",
  NEUTRAL: "neutral",
};
